export const VideoTypes = [
  'Introduction',
  'Elevator Pitch Sample',
  'Video Prospecting Sample',
  'Job Fit',
  'Additional Video',
];
